'use client';
const ACTION_ITEM_VARIANTS = [
    'telegram',
    'call',
    'chat'
];

export { ACTION_ITEM_VARIANTS };
//# sourceMappingURL=ActionItem.contract.js.map
